module.exports = "assets/img/borne-de-recharge.png";